var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.074 56.99c.305-1.763.645-3.7.976-5.638.68-3.92 1.334-7.838 2.048-11.739.157-.878-.104-1.434-.723-2.033-4.036-3.867-8.028-7.777-12.03-11.67-.488-.477-1.02-.93-1.229-1.624-.47-1.608.523-3.076 2.32-3.354 1.987-.313 3.991-.574 5.979-.86 3.897-.556 7.793-1.147 11.698-1.66.759-.104.959-.59 1.22-1.12 1.892-3.815 3.784-7.62 5.667-11.427.732-1.477 1.412-2.98 2.205-4.414.88-1.598 2.833-1.92 4.07-.747.376.356.585.817.812 1.26l5.596 11.313c.688 1.39 1.386 2.78 2.048 4.188.28.582.628.878 1.325.973 5.806.8 11.611 1.66 17.408 2.485 1.142.165 1.996.67 2.38 1.79.392 1.121.017 2.05-.81 2.85l-10.54 10.244c-.723.704-1.43 1.425-2.188 2.086-.488.417-.557.886-.453 1.468.95 5.44 1.9 10.887 2.842 16.335.087.495.183.99.218 1.495.122 2.033-1.683 3.336-3.592 2.597-.34-.13-.653-.321-.985-.495-4.872-2.554-9.754-5.074-14.592-7.69-.933-.503-1.613-.469-2.52.018-4.89 2.615-9.814 5.161-14.722 7.733-.288.148-.558.33-.854.443-1.9.73-3.696-.582-3.583-2.78l.009-.026z",
    fill: "url(#b)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.081 1.934C30.668.868 31.86.739 32.588 1.43c.165.157.277.348.434.65l.174.34 5.59 11.3h.001c.692 1.397 1.382 2.775 2.04 4.17l.002.008c.18.375.424.745.804 1.033.383.29.822.433 1.287.497 5.802.8 11.597 1.658 17.401 2.484v.001c.47.068.802.195 1.038.362.222.158.41.387.538.762l.003.006c.13.372.121.664.042.916-.084.268-.27.564-.603.885l-.003.002-10.54 10.244c-.743.725-1.411 1.407-2.139 2.042a2.33 2.33 0 0 0-.765 1.173c-.119.438-.089.862-.024 1.227v.001c.95 5.44 1.9 10.886 2.841 16.333l.001.003c.091.517.173.946.204 1.38v.001c.042.694-.24 1.193-.621 1.469-.383.277-.952.391-1.61.136h-.003l-.194-.083a4.82 4.82 0 0 1-.193-.1l-.492-.265c-4.88-2.558-9.75-5.072-14.581-7.683-.565-.306-1.14-.493-1.762-.483-.54.01-1.033.165-1.505.396l-.2.102a912.255 912.255 0 0 1-7.347 3.88l-7.361 3.846c-.163.083-.345.19-.453.25a2.36 2.36 0 0 1-.301.147l-.002.001c-.65.25-1.205.133-1.582-.154-.367-.28-.666-.798-.647-1.565.304-1.756.645-3.692.975-5.624.681-3.927 1.333-7.833 2.047-11.727l.001-.004c.103-.577.08-1.125-.121-1.652-.195-.513-.527-.922-.892-1.276l-.004-.004a1126.727 1126.727 0 0 1-6.022-5.819l-6.001-5.844c-.5-.488-.777-.74-.917-1.056l-.052-.14c-.152-.527-.058-.98.176-1.321.24-.349.678-.655 1.338-.757h.003c1.98-.312 3.96-.569 5.967-.859h-.001c3.908-.558 7.788-1.146 11.686-1.658h.006c.61-.084 1.07-.344 1.41-.73.288-.325.469-.731.572-.94h-.002c1.891-3.813 3.784-7.618 5.666-11.423.754-1.521 1.406-2.966 2.185-4.374l.001-.002z",
    stroke: "#E19839",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 31.5,
    y1: 0,
    x2: 31.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE79F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#FFE083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#FFD75A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C62B"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 63,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.929412 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1244_490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGold);
export default __webpack_public_path__ + "static/media/star_gold.3acfec4541bd530bc00d7a1231f59c9f.svg";
export { ForwardRef as ReactComponent };